import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const MASCOT_IMAGE = 'https://cdn.magicpatterns.com/uploads/dm8VbfVJkrkWH6bJRns5AR/Gemini_Generated_Image_p8ospmp8ospmp8os.png';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [pulse, setPulse] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 1000); // Reset pulse after 1s
    }, 30000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-313">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed top-0 left-0 right-0 z-50 bg-[#FFF5EE]/90 backdrop-blur-md border-b border-[#E8D5C4]/50 shadow-sm" data-id="element-314">
          <div className="flex items-center justify-between px-4 md:px-8 py-3 max-w-7xl mx-auto" data-id="element-315">
            {/* Left Side: Mascot with Pulse */}
            <motion.div animate={pulse ? {
          scale: [1, 1.15, 1]
        } : {
          scale: 1
        }} transition={{
          duration: 0.5,
          ease: 'easeInOut'
        }} className="flex-shrink-0" data-id="element-316">
              <img src={MASCOT_IMAGE} alt="Boba Professional Mascot" className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-317" />
            </motion.div>

            {/* Right Side: CTA Button */}
            <motion.button onClick={scrollToPricing} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="bg-[#A8D5BA] hover:bg-[#8FC4A4] text-[#1B4332] font-bold text-xs sm:text-sm md:text-base py-2.5 px-4 md:px-6 rounded-xl transition-colors shadow-sm" data-id="element-318">
              RECLAMAR MI DESCUENTO AHORA
            </motion.button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}